import {types} from 'mobx-state-tree';
import i18n from './translate-store';
import UnitModel from '../models/unit-model';

const SpeedUnitStore = types
    .model('SpeedUnitStore', {
        units: types.optional(types.array(UnitModel), []),
    })
    .actions((self) => ({
        afterCreate() {
            self.setUnits([{
                key: 'kn',
                name: i18n.strings.sharedKn,
                factor: 1,
            }, {
                key: 'kmh',
                name: i18n.strings.sharedKmh,
                factor: 1.852,
            }, {
                key: 'mph',
                name: i18n.strings.sharedMph,
                factor: 1.15078,
            }]);
        },
        setUnits(data) {
            self.units = data;
        },
        findRecord(key, unit) {
            return self.units.find((u) => u[key] === unit);
        },
        convertValue(value, unit, back) {
            if (!unit) {
                unit = 'kn';
            }
            const model = self.findRecord('key', unit);
            return back ? value / model.factor : value * model.factor;
        },

        formatValue(value, unit, convert) {
            if (!unit) {
                unit = 'kn';
            }
            const model = self.findRecord('key', unit);
            return (convert ? self.convertValue(value, unit) : value).toFixed(1) + ' ' + model.name;
        },
    }));

export default SpeedUnitStore;

